import React from 'react';
import DashboardStatCard from './DashboardStatCard';
import { Box, Layers, Award } from 'lucide-react';

const DashboardStats = ({ achievementStats }) => { // <--- Receive prop
  const stats = [
    {
      id: 3,
      title: "Achievements",
      value1: achievementStats?.totalAchievements || 0, // <--- Use prop
      label1: "Awards",
      value2: achievementStats?.totalPoints || 0, // <--- Use prop
      label2: "Points",
      icon: <Award className="w-6 h-6" />,
      color: "yellow"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats?.map((stat) => (
        <DashboardStatCard
          key={stat?.id}
          title={stat?.title}
          value={stat?.value}
          icon={stat?.icon}
          color={stat?.color}
          value1={stat?.value1}
          label1={stat?.label1}
          value2={stat?.value2}
          label2={stat?.label2}
        />
      ))}
    </div>
  );
};

export default DashboardStats;